<div class="chart" [style.grid-template-rows]="gridRows">
  <div class="value-header">
    <div i18n>noch zu wenig reflektiert</div>
    <div i18n>ausreichend reflektiert</div>
  </div>
  <div class="total-text bold center" i18n>Gesamtqualität der Entscheidung</div>
  <div class="bar-background top">
    <div class="background-color"></div>
    <div class="lines"></div>
  </div>
  <div class="bar-background bottom">
    <div class="background-color"></div>
    <div class="lines"></div>
  </div>
  @if (total < 0) {
    <div class="require-text bold high center">
      <span class="backdrop single-line" i18n>Erfordert die Bewertung aller sechs Qualitätskriterien</span></div
    >
  } @else {
    <div class="quality-bar total high center" [style.width.%]="total * 10"></div>
  }
  <div class="seperator center"></div>
  <div class="criteria-text bold center" i18n>Qualitätskriterien</div>
  @for (criteria of dqCriteria; track criteria; let i = $index) {
    <div
      class="criteria single-line center"
      [style.grid-row]="5 + i"
      [matTooltip]="verbalize(criteria)"
      [matTooltipDisabled]="!overflow.isOverflowing"
    >
      <span>{{ i + 1 }}.</span>
      <span class="single-line" #overflow="dtOverflow" [dtOverflow]>{{ verbalize(criteria) }}</span>
    </div>
    @if (criteriaValues[criteria] >= 0) {
      <div
        class="quality-bar high center"
        [class.minimum]="minIndex === i"
        [style.width.%]="criteriaValues[criteria] * 10"
        [style.grid-row]="5 + i"
        (click)="openExplanation(i, criteria)"
      ></div>
    }
    @if (criteriaValues[criteria] < 0.2) {
      <div
        class="requires-assessment high center"
        [class.disabled]="lockedValues[i] && criteriaValues[criteria] < 0"
        (click)="openExplanation(i, criteria)"
        [style.grid-row]="5 + i"
      >
        <button mat-button color="accent" class="backdrop" i18n>Qualität bewerten</button>
      </div>
    }
  }
  <div class="x-scale">
    @for (i of xScale; track i) {
      <div>{{ i }}</div>
    }
  </div>
</div>
